import React from 'react';

import ReactDOM from 'react-dom/client';

import { App } from './App.jsx'; // Make sure this path is correct

ReactDOM.createRoot(
  document.querySelector('#root')
).render(<App />);
